import Routing from 'routing';
import { Button, ButtonSize, ButtonVariant, E1Logo } from '@estimateone/frontend-components';
import { Action, AnalyticsEndpoint, Event, useAnalytics } from '../../../hooks/Analytics';
import styles from './styles.scss';

export const ItpSignupBanner = () => {
  const { addEvent } = useAnalytics(Event.INTERACT, AnalyticsEndpoint.Itp);

  const handleClick = () => {
    addEvent({ action: Action.ITP_SIDE_BANNER_SIGNUP_CLICKED });
    window.location.assign(Routing.generate('app_signup_index', { src: 'itp-banner' }));
  };
  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.contentContainer}>
        <E1Logo width={88} />
        <h2 className={styles.title}>Find more opportunities</h2>
        <p className={styles.subheading}>Be the first to know</p>
        <p>
          See new projects on our noticeboard as soon as they go out to tender, direct from the
          builders that post them.
        </p>
        <ul className={styles.benefitList}>
          <li>569 open tenders on E1 right now</li>
          <li>12,532 projects added in the last 12 months</li>
          <li>$56 billion total value</li>
          <li>Over 150,000 subcontractors and suppliers</li>
        </ul>
        <div className={styles.buttonContainer}>
          <Button variant={ButtonVariant.Primary} size={ButtonSize.Large} onClick={handleClick}>
            Create free account
          </Button>
        </div>
      </div>
    </div>
  );
};
